import React  , {Component} from 'react';
import { Link } from 'react-router-dom';
import './header.nav.styles.css';
import { MenuItems } from './menuItemdatasource';

class Navbar extends Component {
    state = {clicked: false}

    handleClick = () => {
        this.state({clicked: !this.state.clicked})
    }

    viewNavBar = () => {
        const hamburger = document.querySelector(".hamburger");
        const navlinks = document.querySelector(".nav-links");
        hamburger.addEventListener("click",() => {
            navlinks.classList.toggle("open");
        });
        navlinks.addEventListener("click",() => {
            navlinks.classList.toggle("open");
        });
    } ;

    render() {
        return(
            <div >
                <nav className='NavbarItems' className='header'>
                    <div class="hamburger" onClick={this.viewNavBar}>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                    </div>
                    <ul className='nav-links'>
                        {MenuItems.map((item,index) => {
                            return (
                                <li key={index} onClick={this.viewNavBar}>
                                    <Link to={item.link} className='item-link'>
                                        {item.title}
                                    </Link>
                                </li>
                            )
                        })}
                    </ul>
                </nav>
            </div>
        )
    }
}
export default Navbar;